'use strict';

function ctrl($scope, Global, timeFormat, fetchStream, socketIo, settings, usSpinnerService) {
    $scope.global = Global;

    let model = this;
    model.settings = settings;
    model.lineChartIdentifiers = {
        key: false,
        id: false
    };
    model.geoChartIdentifiers = {
        key: false,
        id: false
    };
    model.tableIdentifiers = {
        key: false,
        id: false
    };

    socketIo('/api/first_seen/new_ssl_hosts').then(function(socket) {
        /////////////////
        /// LINECHART ///
        /////////////////

        // register data object
        $scope.main.registerVisual({
                // allSearchDimensionOverride: true, // OPTIONAL setting to set all searches to searchdim (good for tables, but inefficient for other viz)
                refresh: true, // if a number is placed here, it will overwrite the current 1min default
                searchable: true, // optional search param.. no if undefined
                get: {
                    call: 'linechart',
                    socket: socket
                }, // no get default to main url, strings will replace the default (otherwise /[from root])
                grouping: [
                    'hour',
                    'resp_country'
                ],
                type: 'linechart',
                settings: {
                    type: 'bar',
                    xAxis: '',
                    yAxis: '# New IP / Hour'
                },
                searchCategories: {
                    'time': 'Time',
                    'resp_country': 'Responder Country',
                },
                dimension: function(cfObj) {
                    return cfObj.dimension(function(d) {
                        if (d.time - d.hour < 3600) {
                            d.hour = Number(d.hour * 1000);
                            return d.hour;
                        }
                    })
                },
                group: function(dimension) { // groups are optional and should default to a reduce if undefined
                    return dimension.group().reduce(
                        function(p, v) {
                            if (v.count) {
                                p.ip += v.count;
                            }
                            return p;
                        },
                        function(p, v) {
                            if (v.count) {
                                p.ip -= v.count;
                            }
                            return p;
                        },
                        function() {
                            return {
                                ip: 0
                            };
                        }
                    );
                },
            })
            // fetch the data when the object is registered
            .then(function(result) {
                model.lineChartIdentifiers = {
                        id: result.id,
                        key: result.key
                    }
                    // set dimension & group
                $scope.main.dataObjects[model.lineChartIdentifiers.key].dimension = $scope.main.dataObjects[model.lineChartIdentifiers.key].settings.dimension($scope.main.dataObjects[model.lineChartIdentifiers.key].cf);
                $scope.main.dataObjects[model.lineChartIdentifiers.key].group = $scope.main.dataObjects[model.lineChartIdentifiers.key].settings.group($scope.main.dataObjects[model.lineChartIdentifiers.key].dimension);
                // return new fetchStream(result.settings.get.call, result.settings.get.socket);
                return new fetchStream(result.settings.get.call, result.settings.get.socket);
            })
            .then(function(result) {
                // stop spinner on complete
                if (!$scope.main.dataObjects[model.lineChartIdentifiers.key].launched) {
                    usSpinnerService.stop('spinner-' + model.lineChartIdentifiers.id)
                }
            }, function(err) {

            }, function(result) {
                $scope.main.dataObjects[model.lineChartIdentifiers.key].cf.add(result.rows);
                if (!$scope.main.dataObjects[model.lineChartIdentifiers.key].launched) {
                    $scope.$broadcast('init', model.lineChartIdentifiers);
                    // stop spinner on inital data
                    usSpinnerService.stop('spinner-' + model.lineChartIdentifiers.id)
                } else {
                    $scope.$broadcast('updatedData', model.lineChartIdentifiers.id, true);
                }
            })

        ////////////////
        /// GEOCHART ///
        ////////////////

        // register data object
        $scope.main.registerVisual({
                // allSearchDimensionOverride: true, // OPTIONAL setting to set all searches to searchdim (good for tables, but inefficient for other viz)
                refresh: true, // if a number is placed here, it will overwrite the current 1min default
                searchable: true, // optional search param.. no if undefined
                get: {
                    call: 'geomap',
                    socket: socket
                }, // no get default to main url, strings will replace the default (otherwise /[from root])
                type: 'geochart',
                searchCategories: {
                    'resp_country': 'Responder Country',
                },
                dimension: function(cfObj) {
                    return cfObj.dimension(function(d) {
                        return d.resp_country;
                    })
                },
                group: function(dimension) { // groups are optional and should default to a reduce if undefined
                    return dimension.group().reduceSum(function(d) {
                        return d.count
                    }); //Might have to Math.ceil or round
                },
            })
            // fetch the data when the object is registered
            .then(function(result) {
                model.geoChartIdentifiers = {
                        id: result.id,
                        key: result.key
                    }
                    // set dimension & group
                $scope.main.dataObjects[model.geoChartIdentifiers.key].dimension = $scope.main.dataObjects[model.geoChartIdentifiers.key].settings.dimension($scope.main.dataObjects[model.geoChartIdentifiers.key].cf);
                $scope.main.dataObjects[model.geoChartIdentifiers.key].group = $scope.main.dataObjects[model.geoChartIdentifiers.key].settings.group($scope.main.dataObjects[model.geoChartIdentifiers.key].dimension);
                return new fetchStream(result.settings.get.call, result.settings.get.socket);
            })
            // fetch the data when the object is registered
            .then(function(result) {
                // stop spinner on complete or no data
                if (!$scope.main.dataObjects[model.geoChartIdentifiers.key].launched) {
                    usSpinnerService.stop('spinner-' + model.geoChartIdentifiers.id);
                }
            }, function(err) {

            }, function(result) {
                $scope.main.dataObjects[model.geoChartIdentifiers.key].cf.add(result.rows);
                if (!$scope.main.dataObjects[model.geoChartIdentifiers.key].launched) {
                    $scope.$broadcast('init', model.geoChartIdentifiers);
                    // stop spinner on inital data
                    usSpinnerService.stop('spinner-' + model.geoChartIdentifiers.id);
                } else {
                    $scope.$broadcast('updatedData', model.geoChartIdentifiers.id, true);
                }
            })

        /////////////
        /// TABLE ///
        /////////////

        // register data object
        $scope.main.registerVisual({
                // allSearchDimensionOverride: true, // OPTIONAL setting to set all searches to searchdim (good for tables, but inefficient for other viz)
                refresh: true, // TODO: if a number is placed here, it will overwrite the current 1min default
                searchable: true, // optional search param.. no if undefined
                get: {
                    call: 'table',
                    socket: socket
                },
                grouping: ['id'],
                hideToggleBytes: true,
                sort: {
                    direction: '-', // '-' == desc, '+' == asc
                    col: 'time'
                },
                title: 'New SSL Server Names Detected',
                columns: [{
                    title: 'Last Seen',
                    select: 'time',
                    dView: true,
                    link: {
                        type: 'search',
                        val: ['resp_ip'],
                        crumb: false
                    },
                }, {
                    title: 'Origin Stealth',
                    select: 'orig_stealth',
                    dView: true
                }, {
                    title: 'Blocked by Proxy',
                    select: 'proxy_blocked',
                    dView: true
                }, {
                    title: 'Server Name',
                    select: 'server_name',
                    dView: true
                }, {
                    title: 'Responder IP',
                    select: 'resp_ip',
                    dView: true
                }, {
                    title: 'Responder Country',
                    select: 'resp_country',
                    dView: true
                }, {
                    title: 'Flag',
                    select: 'resp_cc',
                    dView: true
                }, {
                    title: 'Responder ASN',
                    select: 'resp_asn_name',
                    dView: true
                }, {
                    title: 'Origin Hostname',
                    select: 'orig_hostname',
                    dView: true
                }, {
                    title: 'Origin User',
                    select: 'orig_user',
                    dView: true
                }, {
                    title: 'Origin IP',
                    select: 'orig_ip',
                    dView: true
                }],
                searchCategories: {
                    'orig_hostname': 'Origin Hostname',
                    'orig_user': 'Origin User',
                    'orig_ip': 'Origin IP',
                    'resp_ip': 'Responder IP',
                    'resp_country': 'Responder Country',
                    'resp_cc': 'Flag',
                    'resp_asn_name': 'Responder ASN',
                    'orig_stealth': 'Origin Stealth',
                    'proxy_blocked': 'Blocked by Proxy',
                    'server_name': 'Server Name',
                }
            })
            // fetch the data when the object is registered
            .then(function(result) {
                model.tableIdentifiers = {
                        id: result.id,
                        key: result.key
                    }
                    // initalize table with column information so it can compile the directive
                $scope.$broadcast('table-build', model.tableIdentifiers);

                let time = angular.copy($scope.main.getTime());
                model.loadStart = time.end
                model.loadEnd = time.end
                    // return promise to build dimensions and groups for table
                return new fetchStream(result.settings.get.call, result.settings.get.socket);
            })
            .then(function(result) {
                model.complete = true;
                // stop the table spinner as soon as the resolve comes in
                usSpinnerService.stop(model.tableIdentifiers.id);
            }, function(err) {

            }, function(result) {
                // add rows
                $scope.main.dataObjects[model.tableIdentifiers.key].cf.add(result.rows);
                if (!$scope.main.dataObjects[model.tableIdentifiers.key].launched) {
                    // with our first data return, we can build dimensions and groups for our data
                    $scope.main.buildDimGroup(result.rows, model.tableIdentifiers).then(function() {
                        // dont start the spinner if the table loads faster than building group dim
                        if (!model.complete) {
                            // start table spinner right before init, but after build
                            usSpinnerService.spin(model.tableIdentifiers.id);
                        }
                        // initalize rows
                        $scope.$broadcast('init', model.tableIdentifiers);
                        if (result.min) {
                            model.loadStart = result.min;
                        }
                    }, function(err) {
                        console.log('error')
                        console.log(err)
                    })
                } else {
                    if (result.min) {
                        model.loadStart = result.min;
                    }
                    $scope.$broadcast('updatedData', model.tableIdentifiers.id);
                }
            })
        $scope.$on('$destroy', function() {
            socket.disconnect();
        });
    })
};

ctrl.$inject = ['$scope', 'Global', 'timeFormat', 'fetchStream', 'socketIo', 'settings', 'usSpinnerService'];
module.exports = ctrl;


/** WEBPACK FOOTER **
 ** ./src/pages/controllers/anomalies/new_ssl_hosts.js
 **/